import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";
import { type SelectType } from "@/types/forms";
import type { JSX } from "react";
import {
  type FieldValues,
  type Path,
  type UseFormReturn,
} from "react-hook-form";

export const FormRadioGroup = <T extends FieldValues>({
  form,
  fieldName,
  fieldLabel,
  options,
  className,
  radioGroupClassName,
}: {
  form: UseFormReturn<T, any, T>;
  fieldName: Path<T>;
  fieldLabel?: string | JSX.Element;
  options: SelectType[];
  className?: string;
  radioGroupClassName?: string;
}) => {
  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => (
        <FormItem className={cn("space-y-3", className)}>
          {fieldLabel && <FormLabel>{fieldLabel}</FormLabel>}
          <FormControl>
            <RadioGroup
              onValueChange={field.onChange}
              defaultValue={field.value}
              className={cn("flex flex-col space-y-1", radioGroupClassName)}
            >
              {options.map((option) => (
                <FormItem
                  key={option.value}
                  className="flex items-center space-x-3 space-y-0"
                >
                  <FormControl>
                    <RadioGroupItem
                      value={option.value}
                      className="border-input data-[state=checked]:border-brand-green-300 data-[state=checked]:bg-brand-green-300 h-5 w-5 text-white [&_svg]:h-2 [&_svg]:w-2"
                    />
                  </FormControl>
                  <FormLabel className="font-normal">{option.label}</FormLabel>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
